<template>
  <a-spin :spinning="loading" tip="Processing...">
  <div class="card mb-3" style="min-height: 60vh;">
    <div class="card-body">
      <div>

        <h3>Inventory Recompute Tool<button class="float-right btn btn-sm btn-success mr-2" v-b-modal.modal-recompute-log @click.prevent="getActionLogs"> <span class="fa fa-logs" /> Action Logs </button></h3> 
          <div class="col-md-12" style="padding: 30px; height: 64vh;">

            <a-steps class="steps-navigator" :current="currentTab" @change="onChangeTab">
              <a-step title="Step 1" description="Check Inventory" :disabled='currentTab == maxTab' />
              <a-step title="Step 2" description="Fix Inventory" :disabled='currentTab == maxTab' />
            </a-steps>

            <div class="col-md-12" v-if="currentTab == 0">
              <div class="col-md-6">
                <p class="header">
                  Select Account, Site then click Check Inventory to check list of product with incorrect inventory.
              </p>
                <base-input label="Account:">
                  <a-select showSearch
                            style="width: 100%"
                            placeholder=""
                            optionFilterProp="children"
                            v-model="selectedAccount">
                    <a-select-option v-for="(account, index) in accounts"
                                      :key="index"
                                      :value="account.id">
                      {{account.account_name}}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>

              <div class="col-md-6">
                <base-input label="Site:">
                  <a-select showSearch
                            style="width: 100%"
                            placeholder=""
                            optionFilterProp="children"
                            v-model="selectedSite">
                    <a-select-option v-for="(site, index) in sites"
                                      :key="index"
                                      :value="site.id">
                      {{site.name}}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>

            </div>

            <div class="col-md-12" v-if="currentTab == 1">
              <div class="card mb-3">
                <div class="row no-gutters" style="min-height: 45vh; overflow: auto;">
                  <div class="col-md-12" style="height: 10vh;">
                    <a-tabs v-model:activeKey="activeKey">
                      <a-tab-pane tab="Recompute inventory of Specific Product" key="1">
                        <div class="ml-3 mt-3 mr-3">
                          <div class="col-md-12">
                            <base-input label="Account: ">
                              <span class="mr-2"> <a-tag color="blue"> {{ selectedInfo.accountName }} </a-tag> </span>
                            </base-input>
                          </div>

                          <div class="col-md-12">
                            <base-input label="Site: ">
                              <span class="mr-2"> <a-tag color="blue"> {{ selectedInfo.siteName }} </a-tag> </span>
                            </base-input>
                          </div>

                          <div class="col-md-6">
                            <base-input label="Product:">
                              <a-select showSearch
                                        style="width: 100%"
                                        placeholder=""
                                        optionFilterProp="children"
                                        v-model="selectedProduct">
                                <a-select-option v-for="(product, index) in products"
                                                  :key="index"
                                                  :value="product.product_id">
                                  {{product.product_id}} - {{product.product_name}}
                                </a-select-option>
                              </a-select>
                            </base-input>
                          </div>
                          <a-table :scroll="{ x: 1 }" size="small" rowKey="product_id" :columns="columns" :data-source="productData" style="min-height: 10vh; overflow: auto;">
                            <span slot="product_status" slot-scope="text, record">
                              <div v-if="record.product_status == 'A'">ACTIVE</div>
                              <div v-if="record.product_status == 'I'">IN-ACTIVE</div>
                              <div v-if="record.product_status == 'D'">DELETED</div>
                            </span>
                          </a-table>
                        </div>  
                      </a-tab-pane>
                      <a-tab-pane tab="Fix inventory of all product of the selected Account and Site" key="2">
                        <div class="ml-3 mt-3 mr-3">
                            <div class="col-md-12">
                                <base-input label="Account: ">
                                  <br><span class="mr-2"> <a-tag color="blue"> {{ selectedInfo.accountName }} </a-tag> </span>
                                </base-input>
                              </div>

                              <div class="col-md-12">
                                <base-input label="Site: ">
                                  <br><span class="mr-2"> <a-tag color="blue"> {{ selectedInfo.siteName }} </a-tag> </span>
                                </base-input>
                              </div>
                              
                              <div class="col-md-12">
                                <base-input label="Product Count: ">
                                  <br><span class="mr-2"> <a-tag color="blue"> {{ products.length }} </a-tag> </span>
                                </base-input>
                              </div>
                              
                              <div class="col-md-12">
                              <base-input label="Is Retry: " class="label-clear-inventory"><br>
                                <a-radio-group name="isRetry" v-model="isRetry">
                                  <a-radio :value="true">
                                    Yes
                                  </a-radio>
                                  <a-radio :value="false">
                                    No
                                  </a-radio>
                                </a-radio-group>
                              </base-input>
                            </div>
                        </div>
                      </a-tab-pane>
                    </a-tabs>
                  </div>
                </div> 
              </div>
            </div>
            
          </div>

        <div class="col-md-12" style="position: absolute; bottom: 0px; width: 98%; background-color: #f2f2f2 ; padding: 10px;">
          <div class="steps-action float-right">

              <vue-json-to-csv v-if="products.length > 0 && currentTab == 0"  :json-data="products" :csv-title="'Incorrect_Inventories_'+currDate.replace(/ /g, '_')">
                      <a-button id='clickCsvExport' type="info" style="margin-left: 8px"> 
                        Download Incorrect Inventories to CSV 
                      </a-button>
              </vue-json-to-csv>

              <a-button
                v-if="currentTab > 0"
                @click="prevStep()"
                :disabled='loading'>
                Previous
              </a-button>

              <a-button
                v-if="currentTab < maxTab && currentTab != 1"
                type="primary"
                @click.prevent="checkInventory()"
                style="margin-left: 8px"
                :disabled='loading'>
                Check Inventory
              </a-button>

              <a-button
                v-if="currentTab < maxTab && currentTab != 1 && JsonData.length > 0"
                @click="nextStep()"
                style="margin-left: 8px"
                :disabled='loading'>
                Next
              </a-button>

              <a-button
                v-if="currentTab == 1 && activeKey == 1"
                type="primary"
                @click.prevent="recomputeInventory()"
                style="margin-left: 8px"
                :disabled='loading'>
                Recompute Inventory
              </a-button>

              <a-popconfirm title="This will run thru jobs, click OK to proceed." @confirm="() => fixAllInventory()">
                <a-button
                  v-if="currentTab == 1 && activeKey == 2"
                  type="primary"
                  style="margin-left: 8px"
                  :disabled='loading'>
                  Fix All Inventory</a-button>
              </a-popconfirm>
          </div>
        </div>

      </div>
    </div>
  </div>

  <b-modal id="modal-recompute-log" ref="modal-recompute-log" size="xl">
        <template slot="modal-header">
          Inventory Recompute Logs
        </template>
        <template slot="default">
          <div class="col-md-12">
            <div class="card-body">
              <div class="table-responsive" >
                <vuetable v-if="tableURL.length > 0"
                          ref="vuetable"
                          :api-url="tableURL"
                          :http-options="httpOptions"
                          :fields="fields"
                          :show-sort-icons="true"
                          :per-page="10"
                          :css="tableCSS.table"
                          pagination-path=""
                          data-path="data"
                          no-data-template="Empty"
                          @vuetable:load-error="onLoadError"
                          @vuetable:pagination-data="onPaginationData"/>
              </div>

              <div class="card-footer d-flex justify-content-end bg-transparent">
                <div class="pagination ui basic segment grid">
                  <vuetable-pagination
                    ref="pagination"
                    @vuetable-pagination:change-page="onChangePage"
                    :css="tableCSS.pagination">
                  </vuetable-pagination>
                </div>
              </div>

            </div>
          </div>
        </template>
        <template #modal-footer="{ close }" class="w-50">
            <b-button  variant="warning" size="sm" class="float-right" @click="close()"> Close </b-button>
        </template>
  </b-modal>

</a-spin>
</template>

<script>
import { mapState } from 'vuex';
import HTTPRequest from '../../controllers/httpRequest.js';
import secureStorage from '../../controllers/secureStorage.js';
import VueJsonToCsv from 'vue-json-to-csv';
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import axios from "axios";
import moment from 'moment';

const defaultData = {
  loading: false,
  currentTab: 0,
  accounts: [],
  sites: [],
  products:[],
  selectedAccount: null,
  selectedSite: null,
  selectedProduct: null,
  selectedInfo: {},
  requestData: {},
  isRetry: false,
  activeKey: '1'
}

const columns = [
  {
    title: 'Product Id',
    dataIndex: 'product_id',
    fixed: 'left',
    align: 'left'
  },
  {
    title: 'Product Description',
    dataIndex: 'product_name',
    align: 'center'
  },
  {
    title: 'Product Status',
    dataIndex: 'product_status',
    scopedSlots: { customRender: 'product_status' },
    align: 'center',
  },
  {
    title: 'Retail Price',
    dataIndex: 'retail_price',
    align: 'right',
  },
  {
    title: 'Landed Cost',
    dataIndex: 'landed_cost',
    align: 'right',
  },
  {
    title: 'Document Quantity',
    dataIndex: 'doc_qty',
    align: 'right',
  },
  {
    title: 'POS Quantity',
    dataIndex: 'pos_qty',
    align: 'right',
  },
  {
    title: 'Total Movement Quantity',
    dataIndex: 'movement_qty',
    align: 'right',
  },
  {
    title: 'Onhand Quantity',
    dataIndex: 'oh_qty',
    align: 'right',
  }
];

export default{
  components: {
          VueJsonToCsv,
          Vuetable,
          VuetablePagination
        },
  data() {
    return {
      maxTab: 1,
      JsonData: [],
      productData: [],
      currDate: moment().format("L_LT").split(":").join(""),
      fields: [
        {name: "action_type", title: "Action"},
        {name: "updates", title: "Parameters"},
        {name: "created_by", title: "Action By"},
        {name : "created_at", title: "Action Date"}
      ],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        }
      },
      tableURL: '',
      tableCSS: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      tableData: [],
      columns,
      ...defaultData
    }
  },
  computed: {
    ...mapState(['endPoint'])
  },
  watch: {
    selectedAccount: function() {
      if (!this.selectedAccount) { return; }

      this.selectedSite = null;
      this.populateSites();
    },
    selectedProduct: function() {
      if (!this.selectedProduct) { return; }
      this.productData = []
      var item = ''
      for (const key in this.JsonData) {
        item = `${key}: ${this.JsonData[key]}`;
        if(item.split(',')[2] == this.selectedProduct){
          var p_item = {
            account_id: Number(item.split(',')[0]),
            site_id: item.split(',')[1],
            product_id: item.split(',')[2],
            product_name: item.split(',')[3],
            product_type: item.split(',')[4],
            product_status: item.split(',')[7],
            retail_price: item.split(',')[5],
            landed_cost: item.split(',')[6],
            doc_qty: item.split(',')[8],
            pos_qty: item.split(',')[9],
            movement_qty: item.split(',')[10],
            oh_qty: item.split(',')[11]
          };
          this.productData.push(p_item)
        }
      }
    },
  },
  mounted: async function() {
    await this.populateAccounts();
    this.tableURL = `${this.endPoint}admin/admin_logs?feature=inventory_recompute_tools`;
  },
  methods: {
    getActionLogs: async function() {
      this.tableURL = `${this.endPoint}admin/admin_logs?feature=inventory_recompute_tool`;
    },

    onLoadError: async function(error) {
      console.log(error)
    },

    onPaginationData: async function(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    onChangeTab(current) {
      const hasErrors = this.isNotValid();
      if (hasErrors) { return; }

      this.currentTab = current;
    },

    prevStep() {
      this.currentTab--;
    },

    async nextStep() {
      const hasErrors = this.isNotValid();
      if (hasErrors) { return; }

      if (this.currentTab + 1 == 1) { this.setSelectedInfo(); }
      
      this.currentTab++;
    },

    async checkInventory() {
      const hasErrors = this.isNotValid();
      if (hasErrors) { return; }

      if (this.currentTab + 1 == 1) { this.setSelectedInfo(); }

      this.getRequestData();
      const _this = this;
      _this.loading = true;
      _this.JsonData = []
      _this.products = []
      const config = {
        method: 'POST',
        url: `${this.endPoint}admin/check_inventory`,
        headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")},
        data: this.requestData
      };
      await axios(config)
      .then(function (response) {
        if (response.error) {
          _this.renderMsg('success', 'Check Inventory Failed', response.error);
        } else {
          _this.renderMsg(response.data['type'], 'Check Inventory', response.data['message']);
          _this.createLogs([], 'check_inventory');
          _this.JsonData = response.data['data']
          var item = ''
          for (const key in _this.JsonData) {
            item = `${key}: ${_this.JsonData[key]}`;
            var p_item = {
              product_id: item.split(',')[2],
              product_name: item.split(',')[3],
              product_type: item.split(',')[4],
              product_status: item.split(',')[7],
              retail_price: item.split(',')[5],
              landed_cost: item.split(',')[6],
              doc_qty: item.split(',')[8],
              pos_qty: item.split(',')[9],
              movement_qty: item.split(',')[10],
              oh_qty: item.split(',')[11]
            };
            _this.products.push(p_item)
          }
          _this.selectedProduct = null
          _this.productData = []
        }
      })
      .catch(function (error) {
        _this.renderMsg('error', 'Error', "Something went wrong on checking inventory.")
      });

      this.loading = false;
    },

    async recomputeInventory(){
      const hasErrors = this.isNotValid();
      if (hasErrors) { return; }

      if (this.selectedProduct === null) {
        this.renderMsg('error', 'Error', 'Please Select Product');
        return;
      } else {
        this.requestData.product_id = this.selectedProduct;
      }

      this.getRequestData();
      const _this = this;
      _this.loading = true;
  
      const config = {
        method: 'POST',
        url: `${this.endPoint}admin/recompute_inventory`,
        headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")},
        data: this.requestData
      };
      await axios(config)
      .then(function (response) {
        if (response.error) {
          _this.renderMsg('success', 'Recomputing Inventory Failed', response.error);
        } else {
          _this.renderMsg(response.data['type'], 'Inventory Recompute', response.data['message']);
          _this.createLogs([], 'recompute_inventory');
          _this.products = _this.products.filter(function( obj ) {
              return obj.product_id !== _this.selectedProduct;
          });
          _this.selectedProduct = null
          _this.productData = []
        }
      })
      .catch(function (error) {
        _this.renderMsg('error', 'Error', "Something went wrong on recomputing inventory. Please rerun check inventory in Step 1.")
      });

      this.loading = false;
    },

    async fixAllInventory(){
      const hasErrors = this.isNotValid();
      if (hasErrors) { return; }

      this.requestData.is_retry = (this.isRetry) ? 1 : 0;
      this.getRequestData();
      const _this = this;
      _this.loading = true;
  
      const config = {
        method: 'POST',
        url: `${this.endPoint}admin/fix_inventory`,
        headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")},
        data: this.requestData
      };
      await axios(config)
      .then(function (response) {
        if (response.error) {
          _this.renderMsg('success', 'Fixing Inventory Failed', response.error);
        } else {
          _this.renderMsg(response.data['type'], 'Fixing Inventory', response.data['message']);
          _this.createLogs([], 'fix_inventory');
          _this.products = []
          _this.selectedProduct = null
          _this.productData = []
        }
      })
      .catch(function (error) {
        _this.renderMsg('error', 'Error', "Something went wrong on fixing inventory. Please rerun check inventory in Step 1.")
      });

      this.loading = false;
    },

    renderMsg(type, msg, desc) {
      this.$notification[type]({ message: msg, description: desc, });
    },

    async populateAccounts() {
      // Get all Valid and Active accounts
      let accounts = await HTTPRequest.getRequest(`${this.endPoint}accounts/get_valid_accounts`, null, null)
      accounts = accounts.sort((a, b) => {
        const textA = a.account_name.toUpperCase();
        const textB = b.account_name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
      this.accounts = accounts || [];
    },

    async populateSites() {
      if (!this.selectedAccount) { return; }

      const sites = await HTTPRequest.getRequest(`${this.endPoint}sites/get_all_valid_sites?account_id=${this.selectedAccount}`, null, null)
      this.sites = sites || [];
    },

    setSelectedInfo() {
      const selectedAccount = this.accounts.filter(account => account.id == this.selectedAccount)[0];
      const selectedSite = this.sites.filter(site => site.id == this.selectedSite)[0];

      this.selectedInfo = {
        accountName: selectedAccount.account_name,
        siteName: selectedSite.name
      }
    },

    getRequestData() {
      
      // Getting account name
      const selectedAccount = this.accounts.filter(account => account.id == this.selectedAccount)[0];
      this.requestData.account_id = selectedAccount.id;

      // Getting site id
      const selectedSite = this.sites.filter(site => site.id == this.selectedSite)[0];
      this.requestData.site_id = selectedSite.id;
    },

    isNotValid: function() {
      let withError = false;
      if (!this.selectedAccount) {
        this.renderMsg('error', 'Error', 'Please Select an Account');
        withError = true;
      } else if (!this.selectedSite) {
        this.renderMsg('error', 'Error', 'Please Select a Site');
        withError = true;
      }

      return withError;
    },

    createLogs: async function (outputData, action) {
      const endPoint = `${this.endPoint}admin/create_admin_logs?feature=${action}`;
      let data = { logs: { ...this.requestData, ...outputData } }
      HTTPRequest.postRequest(endPoint, null, data);
    },
  }
}
</script>

<style scoped>
.steps-navigator {
  margin-bottom: 20px;
}

p.header {
  font-size: 14px;
}

.selectedInfo-cont {
  display: inline-block;
  margin-left: 10px;
}

.selectedInfo-cont div {
  margin-bottom: 10px;
}

.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
    max-width: 500px !important;
    white-space: normal;
}
</style>
